import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Image } from '@sitecore-jss/sitecore-jss-react';

import { getFormattedJSSImage, JssImageType } from 'core/utils/sitecore-utils';

import * as S from './JssImage.style';

interface IProps {
	field?: JssImageType;
}

/**
 * Sitecore never in fact returns a 'null' image, it will instead
 * give us a default 'placeholder' image; however we can discern if
 * this is the case by checking if the adjacent `class` === 'scEmptyImage'.
 */
export const doesImageExist = (field: JssImageType | undefined) => {
	const imageClass = field?.value?.class;

	return imageClass !== 'scEmptyImage';
};

const JssImage = ({ field, ...props }: IProps) =>
	doesImageExist(field) ? (
		<S.Wrapper>
			<Image media={getFormattedJSSImage(field)} {...props} />
		</S.Wrapper>
	) : null;

export default JssImage;
